import React, { useEffect, useState } from "react";
import Buttons from "../../../components/UI/Buttons";
import SectionLoader from "../../../components/UI/SectionLoader";
import PatientChartsService from "../../../services/PatientChartsService";
import { capitalizeName } from "../../../utils/commonUtils";
import { useDispatch } from "react-redux";
import { getGlobalFilterState, updateGlobalFilter } from "../../../store/GlobalFilterSlice";
import { useSelector } from "react-redux";

const WorkRestrictions = (props) => {
    const { data, filter, isLoading } = props;
    const { company_id, clinic_id } = filter;
    const [workStatusList, setWorkStatusList] = useState([]);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const globalFilter = useSelector(getGlobalFilterState);

    useEffect(() => {
        fetchWorkStatusList();
    }, [filter, company_id, clinic_id]);

    const fetchWorkStatusList = async () => {
        setLoading(true);
        try {
            const queryParams = {
                page: 1,
                perPage: 5, // Show only 5 records in dashboard
                sort_by: 'created_at',
                sort_order: 'desc',
            };

            // Add filters if available
            if (company_id) {
                queryParams.company_id = company_id;
            }
            if (clinic_id) {
                queryParams.clinic_id = clinic_id;
            }

            const response = await PatientChartsService.getWorkStatusResult(null, queryParams);
            
            if (response && response.data && response.data.data) {
                setWorkStatusList(response.data.data);
            } else {
                setWorkStatusList([]);
            }
        } catch (error) {
            console.error("Error fetching work status list:", error);
            setWorkStatusList([]);
        } finally {
            setLoading(false);
        }
    };

    const setWorkStatusFilter = () => {
        const visitsFilter = {
            company_id: company_id || '',
            clinic_id: clinic_id || '',
        };
        dispatch(updateGlobalFilter({ ...globalFilter, ['WorkStatus']: visitsFilter }));
    };

    const getPatientName = (item) => {
        if (item.employee_name) {
            return item.employee_name;
        }
        if (item.employee) {
            return `${item.employee.first_name || ''} ${item.employee.last_name || ''}`.trim();
        }
        return '--';
    };

    const getVisitDate = (item) => {
        return item.visit?.visit_date || '--';
    };

    const getVisitTime = (item) => {
        return item.visit?.visit_time || '--';
    };

    return (
        <>
            <div className="sh_cardBox sh_widgets sh_patientdetailwidget" >
                <div className="sh_cardHeader">
                    <div className="form-group d-flex mb-0 justify-content-between align-items-center">
                        <h6 className="text-md font-weight-bold mb-0">
                            <span className="px-2">
                                <Buttons
                                    iconType='DashboardRestrictions'
                                />
                            </span>
                            Work Restrictions
                        </h6>
                    </div>
                </div>
                <div className="sh_cardBody py-0 dashboard_card">
                    <SectionLoader isLoading={loading || isLoading} />
                    <div className="row dashstatusbg-header my-0 py-0 ">
                        <div className="col-5 font-weight-bold"><a>Name</a></div>
                        <div className="col-4 font-weight-bold"><a>Visit Date</a></div>
                        <div className="col-3 font-weight-bold ratescount"><a>Visit Time</a></div>
                    </div>
                    {workStatusList.length > 0 ? (
                        workStatusList.map((item, index) => (
                            <div key={item.work_status_form_id || index} className={`row dashstatusbg ${index === 0 ? 'first' : ''}`}>
                                <div className="col-5 px-0 font-weight-bold">
                                    <a className="forTable_textEllipsis" title={getPatientName(item)}>
                                        {getPatientName(item) || '--'}
                                    </a>
                                </div>
                                <div className="col-4 px-0 font-weight-bold">
                                    <a className="forTable_textEllipsis" title={getVisitDate(item)}>
                                        {getVisitDate(item)}
                                    </a>
                                </div>
                                <div className="col-3 font-weight-bold ratescount">
                                    <a className="forTable_textEllipsis" title={getVisitTime(item)}>
                                        {getVisitTime(item)}
                                    </a>
                                </div>
                            </div>
                        ))
                    ) : (
                        !loading && !isLoading && (
                            <div className="row dashstatusbg first">
                                <div className="col-12 px-0 text-center py-2">
                                    <a>No work status records found</a>
                                </div>
                            </div>
                        )
                    )}
                </div>
                <div className="sh_cardFooter dashboardfooter border-0 pt-0 justify-content-center">
                    <Buttons 
                        className="btn dashboardbtn btn-danger px-4" 
                        clickHandler={() => setWorkStatusFilter()} 
                        href={'/result/workstatus'} 
                        acl={'any'}
                    >
                        Review All
                    </Buttons>
                </div>
            </div>
        </>
    );
}
export default WorkRestrictions;